<template>
  <div class="select-color" v-if="colors">
    <div
      class="select-color__color-btn"
      @click="autocomplete = !autocomplete"
      :style="{
        borderColor: input,
        color: input,
      }"
    >
      {{ input }}
    </div>

    <ul class="select-color-items" v-show="autocomplete">
      <li
        class="select-color-item"
        v-for="item in colors"
        :key="item"
        @click="setItem(item)"
        :style="{ backgroundColor: item }"
      >
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    colors: Array,
    input: String,
  },
  data() {
    return {
      autocomplete: false,
    };
  },
  methods: {
    setItem(item) {
      this.$emit("input", item);
      this.autocomplete = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.select-color {
  display: flex;
  flex-direction: column;
  width: 100%;

  .select-color__color-btn {
    border: 1px solid;
    text-align: center;
    padding: 5px 20px;
    border-radius: 5px;
    cursor: pointer;
    flex: 1;

    &:hover {
      opacity: 0.5;
    }
  }

  .select-color-items {
    position: absolute;
    max-height: 300px;
    overflow: auto;
    margin-top: 35px;
    width: 97px;
    list-style: none;
    padding: 0;
    border-bottom: 1px solid;
    box-shadow: 0 4px 12px -6px #000;
    text-align: center;
    z-index: 1;

    .select-color-item {
      cursor: pointer;
      &:hover {
        background: rgba($color: #000000, $alpha: 0.5);
      }
    }
  }
}
</style>
